import { z } from 'zod'

export const IdParamSchema = z.number()

export const RefParamSchema = z.string()

export const CodeParamSchema = z.string()
